<template>
  <div class="toggle-arrow" :class="parentClasses" v-tooltip="statusName">
    <input type="checkbox" :class="classes" :disabled="disabled" v-bind:checked="status" :id="setID" :name="id" :value="setVal" @change="switchStatus"/>
  </div>
</template>
 
<script lang="ts">
  import Vue from "vue";
  import {StringHelper} from "../helpers/stringHelper";
  export default Vue.extend({
    props: {
      compress: {
        type: Boolean,
        default: false
      },
      check: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data: function(){
      return {
        StringHelper: StringHelper,
        status: this.check,
      }
    },
    methods: {
      switchStatus(): void {
        if (this.disabled) return;
        this.status = !this.status;
        this.$emit('updateDirection', this.statusName)
      },
    },
    computed: {
      classes(){
        return [
          {
            'compress': this.compress
          }
        ];
      },
      parentClasses() {
        return [
          {
            'checked': this.check,
            'disabled': this.disabled
          }
        ]
      },
      setVal(){
        return this.statusName;
      },
      statusName(){
        return this.status ? 'Push' : 'Pull';
      },
      setID(){
        return StringHelper.toDash(this.setVal + '-' + this.id );
      }
    },
  });
</script>
